import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const VoidedSectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  width: 100%;
  padding: ${Spacing.S24};
  background-color: ${Color.Red700};
`
